import { render, staticRenderFns } from "./FlashMessages.vue?vue&type=template&id=528e8ed5&scoped=true&lang=pug&"
import script from "./FlashMessages.vue?vue&type=script&lang=js&"
export * from "./FlashMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e8ed5",
  null
  
)

export default component.exports